export default __webpack_public_path__ + "static/media/icon-stone-policy.39834a56.svg";